import React from "react";
import { ChevronDown } from "lucide-react";
import InfoTag from "./InfoTag";
import {
  METHOD_TAG_APPROVED_CLASS,
  TAG_INFO,
} from "../../Utils/Contant";

const METHOD_ORDER = ["LOCAL", "SWIFT"];

function BeneficiaryList({ beneficiaries, onSelect }) {
  if (!beneficiaries.length) {
    return <p className="text-center text-gray-500 py-4">No payees found</p>;
  }

  return (
    <div className="w-full mx-auto space-y-4 overflow-y-auto max-h-[43vh]">
      <div className="space-y-4">
        {beneficiaries.map((beneficiary, index) => {
          const isRejected = beneficiary?.status === "REJECTED";
          // Not selectable when no method of this payee is approved yet
          const isUnavailable =
            beneficiary?.status?.trim()?.toUpperCase() !== "APPROVED";
          const methods = beneficiary?.methods || {};
          const methodKeys = [
            ...METHOD_ORDER.filter((m) => methods[m]),
            ...Object.keys(methods).filter((m) => !METHOD_ORDER.includes(m)),
          ];
          return (
            <div
              key={index}
              onClick={() => !isUnavailable && onSelect(beneficiary)}
              className={`rounded-lg border border-LightGreyBorder bg-card text-card-foreground ${
                isRejected ? "border-red-500" : ""
              } ${isUnavailable ? "bg-greyShade cursor-not-allowed" : ""}`}
            >
              <div className="flex items-center p-4">
                <div className="flex-shrink-0 mr-4 text-2xl">
                  {/* Flag placeholder */}
                </div>
                <div
                  className={`flex-grow min-w-0 ${
                    isUnavailable ? "opacity-60" : ""
                  }`}
                >
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="font-normal text-blackShade">
                      {beneficiary?.nameOfBeni}
                    </h3>
                    {methodKeys.map((method) =>
                      methods[method] === "APPROVED" ? (
                        <InfoTag
                          key={method}
                          label={method}
                          className={METHOD_TAG_APPROVED_CLASS}
                        />
                      ) : (
                        <InfoTag
                          key={method}
                          label={method}
                          info={TAG_INFO.MANUAL_REVIEW}
                        />
                      )
                    )}
                  </div>
                  <p className="text-xs text-muted-foreground">
                    <span className="text-blackShade mr-1.5">
                      {beneficiary?.maskAccountNo || beneficiary?.iban}
                    </span>
                    <span className="text-greyish text-xs font-normal">
                      {beneficiary?.bankName}
                    </span>
                  </p>
                </div>
                <div className="flex-shrink-0 flex items-center">
                  <span className="text-red-500 text-xs font-normal">
                    {beneficiary?.errorMsg?.replace(/[_"]/g, "")}
                  </span>
                  <ChevronDown
                    className={`${
                      beneficiary?.errorMsg ? "text-red-500" : "text-blackShade"
                    } -rotate-90`}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default BeneficiaryList;
